<template>
    <footer class="container pt-5 pb-2">
        <div class="row text-center">
            <div class="col-12 col-md text-center">
                <b-img class="mx-auto mb-2" height="60" :src="require('../assets/img/branding/' + logoName)"/>
                <small class="d-block f-500 mb-3 text-muted"><span v-tr>Powered by|Propulsé par</span> <a class="mx-1 text-secondary" target="_blank" href="https://eye-in.com">Eye-In Wireless</a> © {{$moment().year()}}</small>
                <small class="d-block f-500 mb-3 text-muted"><span v-tr>To Contact Us|Pour nous contacter</span> <a class="mx-1 text-secondary" target="_blank" href="mailto:support@eyeinmedia.com">support@eyeinmedia.com</a></small>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: `app-footer`
    }
</script>

<style lang="scss" scoped>

</style>
